jQuery(document).ready(function ($) {
  var $wrapperMenuMobile = $(".wrapper-menu-mobile");
  var $navbarToggler = $(".navbar-toggler");
  var $header = $("header");
  var $bgHeader = $(".bg-header");
  var $headerSticky = $(".header-sticky");
  var $headerLogo = $(".block-system-branding-block").find("svg");
  var $mobileMenuNav = $wrapperMenuMobile.find("nav");
  var $mobilePostToc = $(".single-post-template__toc-mobile");
  var isArticlePage = $("body").hasClass("single-post");
  var isBlogPage = $("body").hasClass("blog");
  var isNotFoundPage = $("body").hasClass("error404");

   var startTime = null;
    var duration = 1800;
    
    function easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }
    
    function animate(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        var easeProgress = easeInOutQuad(progress);
        
        var pos1Start = 69.03;
        var pos1End = 22.81;
        var pos2Start = 88.6;
        var pos2End = 100;
        var opacityEnd = 0.50;
        
        var pos1 = pos1Start + (pos1End - pos1Start) * easeProgress;
        var pos2 = pos2Start + (pos2End - pos2Start) * easeProgress;
        var opacity = opacityEnd * easeProgress;
        
        $('.fixed-colored').css('background', 'linear-gradient(164deg, rgba(0, 170, 188, 0) ' + pos1 + '%, rgba(0, 170, 188, ' + opacity + ') ' + pos2 + '%), var(--secondary3, #1B3D56)');
        
        if (progress < 1) {
            requestAnimationFrame(animate);
        }
    }
    
    requestAnimationFrame(animate);

  function updateMobileMenuScrollHint() {
    if (!$mobileMenuNav.length) {
      return;
    }

    $wrapperMenuMobile.toggleClass(
      "has-scrolled-down",
      $mobileMenuNav.scrollTop() > 8,
    );
  }

  function updateDesktopHeaderBackground() {
    if (isArticlePage || isBlogPage || isNotFoundPage) {
      $bgHeader.addClass("bg-fullscreen-secondary3");
      return;
    }
    if ($(window).width() < 990) {
      return;
    }

    if ($(window).scrollTop() <= 0) {
      $bgHeader.addClass("bg-fullscreen-trasparent");
      $bgHeader.removeClass("bg-fullscreen-secondary3");
      return;
    }

    $bgHeader.removeClass("bg-fullscreen-trasparent");
    $bgHeader.addClass("bg-fullscreen-secondary3");
  }

  function updateMobilePostTocOffset() {
    $mobilePostToc.toggleClass("is-header-fixed", $headerSticky.hasClass("fixed"));
  }

  // Aggiungi background header su dekstop al caricamento della pagina
  if ($(window).width() >= 990) {
    updateDesktopHeaderBackground();
  } else {
    // Se da mobile, rimuovilo
    $bgHeader.removeClass("bg-fullscreen-secondary3");
    if (
      $("body").hasClass("single-post") ||
      $("body").hasClass("error404") ||
      $("body").hasClass("error403")
    ) {
      $bgHeader.addClass("bg-fullscreen bg-fullscreen-secondary3");
    }
  }

  // Aggiungi padding top se l'header è fixed
  if ($header.hasClass("header-sticky")) {
    $("body").addClass("top-adjust");
  }

  // Comportamento allo scroll
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    var isMenuOpen = $wrapperMenuMobile.hasClass("show");
    var isSinglePost = $("body").hasClass("single-post");

    // Header sticky
    if (!isMenuOpen) {
      $headerSticky.toggleClass("fixed", scroll > 100);
      updateMobilePostTocOffset();
    }

    // Background header mobile
    if ($(window).width() < 990) {
      if (isMenuOpen) {
        // Menu aperto, niente sfondo
        $bgHeader.removeClass("bg-fullscreen-secondary3");
        $headerLogo.addClass("svg-mobile-active");
      } else if (
        $headerSticky.hasClass("fixed") ||
        isSinglePost ||
        $("body").hasClass("error404") ||
        $("body").hasClass("error403")
      ) {
        // Header fixed o single post --> sfondo acceso
        $bgHeader.addClass("bg-fullscreen-secondary3");
        $headerLogo.removeClass("svg-mobile-active");
      } else {
        // Background spento altrimenti
        $bgHeader.removeClass("bg-fullscreen-secondary3");
        $headerLogo.removeClass("svg-mobile-active");
      }
    } else {
      updateDesktopHeaderBackground();
    }
  });

  // Comportamento al click su nav menu
  $navbarToggler.on("click", function () {
    $wrapperMenuMobile.toggleClass("show");
    $navbarToggler.toggleClass("is-toggled");
    $header.toggleClass("mobile-menu-open");

    if ($wrapperMenuMobile.hasClass("show")) {
      $("body").addClass("no-scroll");
      $("html").addClass("no-scroll");
      updateMobileMenuScrollHint();
    } else {
      $("body").removeClass("no-scroll");
      $("html").removeClass("no-scroll");
      $wrapperMenuMobile.removeClass("has-scrolled-down");
    }

    // Menu aperto --> Background off
    if ($(window).width() < 990) {
      if ($wrapperMenuMobile.hasClass("show")) {
        $headerLogo.addClass("svg-mobile-active");
      } else {
        if (!$header.hasClass("mobile-menu-open")) {
          $headerLogo.removeClass("svg-mobile-active");
        }
      }
    }
  });

  $mobileMenuNav.on("scroll", function () {
    updateMobileMenuScrollHint();
  });

  function closeSubmenu($dropdown) {
    $dropdown.removeClass("submenu-active");
    $dropdown
      .children(".item-parent-menu")
      .removeClass("submenu-active")
      .attr("aria-expanded", "false");
    $dropdown.children(".sub-menu").removeClass("submenu-active");
  }

  function openSubmenu($dropdown) {
    $dropdown.addClass("submenu-active");
    $dropdown
      .children(".item-parent-menu")
      .addClass("submenu-active")
      .attr("aria-expanded", "true");
    $dropdown.children(".sub-menu").addClass("submenu-active");
  }

  function closeAllSubmenus() {
    $(".dropdown.submenu-active").each(function () {
      closeSubmenu($(this));
    });
  }

  $(".dropdown").on("mouseover", function () {
    var $dropdown = $(this);

    if ($(window).width() < 990 || !$dropdown.children(".sub-menu").length) {
      return;
    }

    $dropdown.siblings(".dropdown").each(function () {
      closeSubmenu($(this));
    });

    openSubmenu($dropdown);
  });

  $(".dropdown").on("mouseleave", function () {
    var $dropdown = $(this);

    if ($(window).width() < 990 || !$dropdown.children(".sub-menu").length) {
      return;
    }

    closeSubmenu($dropdown);
  });

  $(".item-parent-menu").on("click", function (event) {
    var $trigger = $(this);
    var $dropdown = $trigger.closest(".dropdown");
    var $submenu = $dropdown.children(".sub-menu");
    var isOpen = $trigger.hasClass("submenu-active");

    if (!$submenu.length || $(window).width() >= 990) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    $dropdown.siblings(".dropdown").each(function () {
      closeSubmenu($(this));
    });

    if (isOpen) {
      closeSubmenu($dropdown);
    } else {
      openSubmenu($dropdown);
    }
  });

  $(document).on("click", function (event) {
    if (
      $(window).width() >= 990 ||
      $(event.target).closest(".dropdown").length
    ) {
      return;
    }

    closeAllSubmenus();
  });

  $(window).on("resize", function () {
    closeAllSubmenus();
  });

  // Accordion
  $(".accordion__wrapper__title").on("click", function () {
    $(this).toggleClass("is-open");
    $(this).children(".accordion__icon").toggleClass("open");
    let content = this.nextElementSibling;
    content.style.maxHeight = content.style.maxHeight
      ? null
      : content.scrollHeight + "px";
  });

  // Single post summary anchor
  $(".single-hero_header__summary-link a").on("click", function (event) {
    var targetSelector = $(this).attr("href");
    var $target = $(targetSelector);
    var summaryOffset = 140;

    if (!$target.length) {
      return;
    }

    event.preventDefault();

    $("html, body").animate(
      {
        scrollTop: Math.max($target.offset().top - summaryOffset, 0),
      },
      550,
    );
  });

  // Swiper
  var cs2Swiper = new Swiper(".swiper-slider", {
    loop: true,
    slidesPerView: 1.2,
    centeredSlides: false,
    spaceBetween: 10,
    autoHeight: true,

    scrollbar: {
      el: ".swiper-scrollbar",
    },
    pagination: {
      el: ".swiper-pagination",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      576: {
        slidesPerView: 2,
        centeredSlides: false,
      },

      768: {
        slidesPerView: 3,
        centeredSlides: false,
      },
    },
  });

  // Swiper Reviews
  var cs2Swiper = new Swiper(".swiper-reviews", {
    loop: true,
    slidesPerView: 1,
    centeredSlides: false,
    spaceBetween: 12,
    autoHeight: true,
    autoplay: {
      delay: 4000
    },
    scrollbar: {
      el: ".swiper-scrollbar",
    },
    pagination: {
      el: ".swiper-pagination",
    },
    navigation: {
      nextEl: ".swiper-button-reviews-next",
      prevEl: ".swiper-button-reviews-prev",
    },
  });

  // Swiper Services Cards
  $(".swiper-services-cards").each(function () {
    var sliderElement = this;
    var $section = $(sliderElement).closest(".section__services-cards");

    new Swiper(sliderElement, {
      loop: false,
      slidesPerView: 1.15,
      centeredSlides: false,
      spaceBetween: 12,
      autoHeight: false,
      watchOverflow: true,
      pagination: {
        el: $section.find(".swiper-pagination-services-cards").get(0),
        clickable: true,
      },
      navigation: {
        nextEl: $section.find(".swiper-button-services-cards-next").get(0),
        prevEl: $section.find(".swiper-button-services-cards-prev").get(0),
      },
      breakpoints: {
        576: {
          slidesPerView: 1.15,
          centeredSlides: false,
          spaceBetween: 12,
        },
        768: {
          slidesPerView: 2,
          centeredSlides: false,
          spaceBetween: 24,
        },
        1200: {
          slidesPerView: 3,
          centeredSlides: false,
          spaceBetween: 24,
        },
      },
    });
  });

  // Swiper Blog Teaser
  $(".swiper-blog-teaser").each(function () {
    var sliderElement = this;
    var $section = $(sliderElement).closest(".blog_section");
    var currentElement = $section.find(".blog-teaser-current").get(0);
    var totalElement = $section.find(".blog-teaser-total").get(0);

    function updateBlogTeaserFraction(swiper) {
      if (!currentElement || !totalElement || !swiper) {
        return;
      }
      // Count only original slides (ignore duplicated slides created by loop)
      var slides = swiper.slides ? Array.prototype.slice.call(swiper.slides) : [];
      var totalSwipers = slides.filter(function (s) {
        return !s.classList.contains("swiper-slide-duplicate");
      }).length || 1;

      // When loop is enabled use realIndex for the current slide (0-based)
      var currentIndex = typeof swiper.realIndex === "number" ? swiper.realIndex : swiper.snapIndex || 0;
      var currentSwiper = (currentIndex % totalSwipers) + 1;

      currentElement.textContent = String(currentSwiper);
      totalElement.textContent = String(totalSwipers);
    }

    new Swiper(sliderElement, {
      loop: true,
      slidesPerView: 1.08,
      centeredSlides: false,
      spaceBetween: 12,
      autoHeight: false,
      watchOverflow: true,
      /* autoplay : {
        delay: 4000
      }, */
      navigation: {
        nextEl: $section.find(".swiper-button-blog-teaser-next").get(0),
        prevEl: $section.find(".swiper-button-blog-teaser-prev").get(0),
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          centeredSlides: false,
          spaceBetween: 24,
        },
        992: {
          slidesPerView: 2,
          centeredSlides: false,
          spaceBetween: 24,
        },
      },
      on: {
        init: updateBlogTeaserFraction,
        slideChange: updateBlogTeaserFraction,
        breakpoint: updateBlogTeaserFraction,
        resize: updateBlogTeaserFraction,
      },
    });
  });

  // Swiper Gallery Slider
  $(".swiper-gallery-slider").each(function () {
    var sliderElement = this;
    var $section = $(sliderElement).closest(".gallery_slider_wrapper");
    var currentElement = $section.find(".gallery-slider-current").get(0);
    var totalElement = $section.find(".gallery-slider-total").get(0);
    var slidesMobile = parseFloat(sliderElement.dataset.slidesMobile) || 1.08;
    var slidesTablet = parseFloat(sliderElement.dataset.slidesTablet) || 2;
    var slidesDesktop = parseFloat(sliderElement.dataset.slidesDesktop) || 2;
    var spaceMobile = parseFloat(sliderElement.dataset.spaceMobile) || 12;
    var spaceDesktop = parseFloat(sliderElement.dataset.spaceDesktop) || 24;

     function updateGallerySliderFraction(swiper) {
      if (!currentElement || !totalElement || !swiper) {
        return;
      }
      // Count only original slides (ignore duplicated slides created by loop)
      var slides = swiper.slides ? Array.prototype.slice.call(swiper.slides) : [];
      var totalSwipers = slides.filter(function (s) {
        return !s.classList.contains("swiper-slide-duplicate");
      }).length || 1;

      // When loop is enabled use realIndex for the current slide (0-based)
      var currentIndex = typeof swiper.realIndex === "number" ? swiper.realIndex : swiper.snapIndex || 0;
      var currentSwiper = (currentIndex % totalSwipers) + 1;

      currentElement.textContent = String(currentSwiper);
      totalElement.textContent = String(totalSwipers);
    }

    new Swiper(sliderElement, {
      loop: true,
      slidesPerView: slidesMobile,
      centeredSlides: false,
      spaceBetween: spaceMobile,
      autoHeight: false,
      watchOverflow: true,
      autoplay: {
        delay: 4000,
      },
      navigation: {
        nextEl: $section.find(".swiper-button-gallery-slider-next").get(0),
        prevEl: $section.find(".swiper-button-gallery-slider-prev").get(0),
      },
      breakpoints: {
        768: {
          slidesPerView: slidesTablet,
          centeredSlides: false,
          spaceBetween: spaceDesktop,
        },
        992: {
          slidesPerView: slidesDesktop,
          centeredSlides: false,
          spaceBetween: spaceDesktop,
        },
      },
      on: {
        init: updateGallerySliderFraction,
        slideChange: updateGallerySliderFraction,
        breakpoint: updateGallerySliderFraction,
        resize: updateGallerySliderFraction,
      },
    });
  });

  // Swiper Info
  $(".swiper-slider-info").each(function () {
    var sliderElement = this;
    var $section = $(sliderElement).closest(".section__slider-info");

    new Swiper(sliderElement, {
      loop: false,
      slidesPerView: 1.2,
      centeredSlides: false,
      spaceBetween: 0,
      autoHeight: false,
      pagination: {
        el: $section.find(".swiper-pagination-slider-info").get(0),
        clickable: true,
      },
      navigation: {
        nextEl: $section.find(".swiper-button-slider-info-next").get(0),
        prevEl: $section.find(".swiper-button-slider-info-prev").get(0),
      },
      breakpoints: {
        567: {
          slidesPerView: 1.2,
          centeredSlides: false,
        },
        991: {
          slidesPerView: 3,
          centeredSlides: false,
        },
        1336: {
          slidesPerView: 4,
          centeredSlides: false,
        },
      },
    });
  });

  // Redirect dopo invio form CF7
  document.addEventListener(
    "wpcf7mailsent",
    function (event) {
      if (event.detail.contactFormId != "4034") {
        setTimeout(() => {
          location = "/thank-you/";
        }, 3000);
      }
    },
    false,
  );

    function clampText($el, maxLines = 3) {
      let lineHeight = parseFloat($el.css("line-height"));

      // fallback se line-height = normal
      if (isNaN(lineHeight)) {
        lineHeight = parseFloat($el.css("font-size")) * 1.2;
      }

      const maxHeight = lineHeight * maxLines + 1;

      if (!$el.data("original-text")) {
        $el.data("original-text", $el.text());
      }

      let text = $el.data("original-text");
      $el.text(text);

      while ($el[0].scrollHeight > maxHeight && text.length > 0) {
        text = text.slice(0, -1);
        $el.text(text + "...");
      }
    }

    function applyClamp() {
      $(
        ".section__services-cards__swiper .section__services-cards__card__description",
      ).each(function () {
        clampText($(this), 8); // 👈 ora 5 funziona
      });
    }

    $(document).ready(applyClamp);
    $(window).on("resize", applyClamp);
});
